var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('datatable',{attrs:{"title":"Applicant Educations","fields":_vm.fields,"response":_vm.data},on:{"create":_vm.createEducation,"delete":_vm.deleteEducation,"edit_click":_vm.editClick}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }